import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import { svgLogoBase64 } from "../../Constants/config";

const InDepthStrategyDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [investmentProductName, setinvestmentProductName] = useState("");
  const navigate = useNavigate();
  const DownloadRef = useRef();
  const { showToast } = useToast();

  const [strategyData, setStrategyData] = useState([
    {
      name: "Growth",
      id: 1,
      products: [
        {
          name: "Australian Equity",
          color_code: "4472C4",
          id: 1,
          stocks: [
            {
              stock_id: 17,
              stock_name: "iShares Edge MSCI Australia Minimum Volatility ETF",
              asx_code: "MVOL",
              quantity: 728,
              current_price: 34.61,
              current_value: 25196.08,
              current_percentage: 3.35,
              target_percentage: 3.25,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 24421.36,
              difference_value: 774.72,
              difference_percentage: 0.1,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 18,
              stock_name: "VanEck Vectors Small Companies Masters ETF",
              asx_code: "MVS",
              quantity: 822,
              current_price: 19.79,
              current_value: 16267.38,
              current_percentage: 2.16,
              target_percentage: 2,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 15028.53,
              difference_value: 1238.85,
              difference_percentage: 0.16,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 13,
              stock_name: "iShares Core S&P/ASX 200 ETF",
              asx_code: "IOZ",
              quantity: 745,
              current_price: 29.59,
              current_value: 22044.55,
              current_percentage: 2.93,
              target_percentage: 3.5,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 26299.93,
              difference_value: -4255.38,
              difference_percentage: -0.57,
              action: "buy",
              action_value: 4255.38,
              action_quantity: 143,
            },
          ],
          current_value: 63508.01,
          target_value: 65749.82,
          difference_value: -2241.81,
          current_percentage: 8.45,
          target_percentage: 8.75,
          difference_percentage: -0.3,
          action: "none",
          action_value: 0,
        },
        {
          name: "Australian Property",
          color_code: "A5A5A5",
          id: 3,
          stocks: [
            {
              stock_id: 26,
              stock_name: "Vanguard Australian Property Securities Index ETF",
              asx_code: "VAP",
              quantity: 298,
              current_price: 84.36,
              current_value: 25139.28,
              current_percentage: 3.35,
              target_percentage: 2,
              product_id: 3,
              product_name: "Australian Property",
              category_id: 1,
              category_name: "Growth",
              color_code: "A5A5A5",
              target_value: 15028.53,
              difference_value: 10110.75,
              difference_percentage: 1.35,
              action: "sell",
              action_value: 10110.75,
              action_quantity: 119,
            },
          ],
          current_value: 25139.28,
          target_value: 15028.53,
          difference_value: 10110.75,
          current_percentage: 3.35,
          target_percentage: 2,
          difference_percentage: 1.35,
          action: "sell",
          action_value: 10110.75,
        },
        {
          name: "Global Equity",
          color_code: "ED7D31",
          id: 2,
          stocks: [
            {
              stock_id: 12,
              stock_name: "iShares Global 100 ETF",
              asx_code: "IOO",
              quantity: 154,
              current_price: 158.3,
              current_value: 24378.2,
              current_percentage: 3.24,
              target_percentage: 3,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 22542.8,
              difference_value: 1835.4,
              difference_percentage: 0.24,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 123,
              stock_name: "iShares S&P 500 AUD Hedged ETF",
              asx_code: "IHVV",
              quantity: 235,
              current_price: 44.66,
              current_value: 10495.1,
              current_percentage: 1.4,
              target_percentage: 1.75,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 13149.96,
              difference_value: -2654.86,
              difference_percentage: -0.35,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 28,
              stock_name: "Vanguard FTSE Emerging Markets Shares ETF",
              asx_code: "VGE",
              quantity: 194,
              current_price: 77.68,
              current_value: 15069.92,
              current_percentage: 2.01,
              target_percentage: 1.75,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 13149.96,
              difference_value: 1919.96,
              difference_percentage: 0.26,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 23,
              stock_name: "VanEck MSCI International Quality ETF",
              asx_code: "QUAL",
              quantity: 340,
              current_price: 51.85,
              current_value: 17629,
              current_percentage: 2.35,
              target_percentage: 2.75,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 20664.23,
              difference_value: -3035.23,
              difference_percentage: -0.4,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
          ],
          current_value: 67572.22,
          target_value: 69506.95,
          difference_value: -1934.73,
          current_percentage: 8.99,
          target_percentage: 9.25,
          difference_percentage: -0.26,
          action: "none",
          action_value: 0,
        },
      ],
      current_value: 156219.51,
      target_value: 150285.3,
      difference_value: 5934.21,
      current_percentage: 20.79,
      target_percentage: 20,
      difference_percentage: 0.79,
      action: "sell",
      action_value: 5934.21,
    },
    {
      name: "Defensive",
      id: 2,
      products: [
        {
          name: "Australian Bonds",
          color_code: "70AD47",
          id: 6,
          stocks: [
            {
              stock_id: 24,
              stock_name: "VanEck Australian Subordinated Debt ETF",
              asx_code: "SUBD",
              quantity: 1978,
              current_price: 24.97,
              current_value: 49390.66,
              current_percentage: 6.57,
              target_percentage: 7,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 52599.86,
              difference_value: -3209.2,
              difference_percentage: -0.43,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 4,
              stock_name: "VanEck Vectors Australian Floating Rate ETF",
              asx_code: "FLOT",
              quantity: 3829,
              current_price: 24.97,
              current_value: 95610.13,
              current_percentage: 12.72,
              target_percentage: 13.5,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 101442.58,
              difference_value: -5832.45,
              difference_percentage: -0.78,
              action: "buy",
              action_value: 5832.45,
              action_quantity: 233,
            },
            {
              stock_id: 6,
              stock_name: "iShares Core Composite Bond ETF",
              asx_code: "IAF",
              quantity: 275,
              current_price: 103.42,
              current_value: 28440.5,
              current_percentage: 3.78,
              target_percentage: 4,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 30057.06,
              difference_value: -1616.56,
              difference_percentage: -0.22,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 21,
              stock_name: "VanEck Vectors Australian Corporate Bond Plus ETF",
              asx_code: "PLUS",
              quantity: 3957,
              current_price: 17.1,
              current_value: 67664.7,
              current_percentage: 9,
              target_percentage: 7,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 52599.86,
              difference_value: 15064.84,
              difference_percentage: 2,
              action: "sell",
              action_value: 15064.84,
              action_quantity: 880,
            },
          ],
          current_value: 241105.99,
          target_value: 236699.36,
          difference_value: 4406.63,
          current_percentage: 32.09,
          target_percentage: 31.5,
          difference_percentage: 0.59,
          action: "sell",
          action_value: 4406.63,
        },
        {
          name: "Australian Cash",
          color_code: "9E480E",
          id: 9,
          stocks: [
            {
              stock_id: 1,
              stock_name: "BetaShares Australian High Interest Cash ETF",
              asx_code: "AAA",
              quantity: 2818,
              current_price: 50.21,
              current_value: 141491.78,
              current_percentage: 18.83,
              target_percentage: 20,
              product_id: 9,
              product_name: "Australian Cash",
              category_id: 2,
              category_name: "Defensive",
              color_code: "9E480E",
              target_value: 150285.31,
              difference_value: -8793.53,
              difference_percentage: -1.17,
              action: "buy",
              action_value: 8793.53,
              action_quantity: 175,
            },
            {
              stock_id: 93,
              stock_name: "Platform CASH",
              asx_code: "CASH",
              quantity: 210500,
              current_price: 1,
              current_value: 210500,
              current_percentage: 28.01,
              target_percentage: 3,
              product_id: 9,
              product_name: "Australian Cash",
              category_id: 2,
              category_name: "Defensive",
              color_code: "9E480E",
              target_value: 22542.8,
              difference_value: 187957.2,
              difference_percentage: 25.01,
              action: "sell",
              action_value: 187957.2,
              action_quantity: 0,
            },
          ],
          current_value: 351991.78,
          target_value: 172828.11,
          difference_value: 179163.67,
          current_percentage: 46.84,
          target_percentage: 23,
          difference_percentage: 23.84,
          action: "sell",
          action_value: 179163.67,
        },
        {
          name: "Global Bonds",
          color_code: "264478",
          id: 7,
          stocks: [
            {
              stock_id: 118,
              stock_name: "iShares Core Global Corporate Bond (AUD Hedged) ETF",
              asx_code: "IHCB",
              quantity: 542,
              current_price: 110.71,
              current_value: 60004.82,
              current_percentage: 7.99,
              target_percentage: 8.5,
              product_id: 7,
              product_name: "Global Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "264478",
              target_value: 63871.26,
              difference_value: -3866.44,
              difference_percentage: -0.51,
              action: "buy",
              action_value: 3866.44,
              action_quantity: 34,
            },
            {
              stock_id: 119,
              stock_name:
                "iShares J.P. Morgan USD Emerging Markets Bond (AUD Hedged) ETF",
              asx_code: "IHEB",
              quantity: 951,
              current_price: 74.24,
              current_value: 70602.24,
              current_percentage: 9.4,
              target_percentage: 10,
              product_id: 7,
              product_name: "Global Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "264478",
              target_value: 75142.65,
              difference_value: -4540.41,
              difference_percentage: -0.6,
              action: "buy",
              action_value: 4540.41,
              action_quantity: 61,
            },
            {
              stock_id: 27,
              stock_name:
                "Vanguard International Credit Securities Index (Hedged) ETF",
              asx_code: "VCF",
              quantity: 1540,
              current_price: 38.61,
              current_value: 59459.4,
              current_percentage: 7.91,
              target_percentage: 7,
              product_id: 7,
              product_name: "Global Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "264478",
              target_value: 52599.86,
              difference_value: 6859.54,
              difference_percentage: 0.91,
              action: "sell",
              action_value: 6859.54,
              action_quantity: 177,
            },
          ],
          current_value: 190066.46,
          target_value: 191613.77,
          difference_value: -1547.31,
          current_percentage: 25.29,
          target_percentage: 25.5,
          difference_percentage: -0.21,
          action: "none",
          action_value: 0,
        },
      ],
      current_value: 783164.23,
      target_value: 601141.24,
      difference_value: 182022.99,
      current_percentage: 104.22,
      target_percentage: 80,
      difference_percentage: 24.22,
      action: "sell",
      action_value: 182022.99,
    },
  ]);
  const [secondStrategyData, setSecondStrategyData] = useState([
    {
      name: "Growth",
      id: 1,
      products: [
        {
          name: "Australian Equity",
          color_code: "4472C4",
          id: 1,
          stocks: [
            {
              stock_id: 2,
              stock_name: "Betashares Australian Quality ETF",
              asx_code: "AQLT",
              quantity: 2304,
              current_price: 28.01,
              current_value: 64535.04,
              current_percentage: 80,
              target_percentage: 80,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 64535.04,
              difference_value: 0,
              difference_percentage: 0,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
          ],
          current_value: 64535.04,
          target_value: 64535.04,
          difference_value: 0,
          current_percentage: 80,
          target_percentage: 80,
          difference_percentage: 0,
          action: "none",
          action_value: 0,
        },
      ],
      current_value: 64535.04,
      target_value: 64535.04,
      difference_value: 0,
      current_percentage: 80,
      target_percentage: 80,
      difference_percentage: 0,
      action: "none",
      action_value: 0,
    },
    {
      name: "Defensive",
      id: 2,
      products: [
        {
          name: "Australian Cash",
          color_code: "9E480E",
          id: 9,
          stocks: [
            {
              stock_id: 93,
              stock_name: "Platform CASH",
              asx_code: "CASH",
              quantity: 20154,
              current_price: 1,
              current_value: 20154,
              current_percentage: 24.98,
              target_percentage: 20,
              product_id: 9,
              product_name: "Australian Cash",
              category_id: 2,
              category_name: "Defensive",
              color_code: "9E480E",
              target_value: 16133.76,
              difference_value: 4020.24,
              difference_percentage: 4.98,
              action: "sell",
              action_value: 4020.24,
              action_quantity: 0,
            },
          ],
          current_value: 20154,
          target_value: 16133.76,
          difference_value: 4020.24,
          current_percentage: 24.98,
          target_percentage: 20,
          difference_percentage: 4.98,
          action: "sell",
          action_value: 4020.24,
        },
      ],
      current_value: 20154,
      target_value: 16133.76,
      difference_value: 4020.24,
      current_percentage: 24.98,
      target_percentage: 20,
      difference_percentage: 4.98,
      action: "sell",
      action_value: 4020.24,
    },
  ]);
  const [isLoadingRebalacing, setIsLoadingRebalacing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "csv", label: "CSV" },
  ];
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden

  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      // if (option.value == "csv") {
      //   try {
      //     const csvBlob = await GetCSV();
      //     const url = window.URL.createObjectURL(csvBlob);
      //     const a = document.createElement("a");
      //     a.href = url;
      //     a.download = `Investment Portfolios-${formattedDate}.csv`;
      //     document.body.appendChild(a);
      //     a.click();
      //     document.body.removeChild(a);
      //     window.URL.revokeObjectURL(url);
      //   } catch (err) {
      //     if (err.message.includes("401")) {
      //       localStorage.removeItem("jwtToken");
      //       navigate("/login");
      //     }
      //     if (err.message.includes("400")) {
      //       toast.error(
      //         <div className="flex items-center">
      //           <div className="mr-3">
      //             <img
      //               src="/tick-error.svg"
      //               alt="Success Icon"
      //               className="h-6 w-6"
      //             />
      //           </div>
      //           <div>
      //             <h3 className="font-semibold text-md text-black">Error!</h3>
      //             <p className="text-sm text-black">{err.message}</p>
      //           </div>
      //         </div>,
      //         {
      //           position: "top-right",
      //           autoClose: 5000,
      //           hideProgressBar: true,
      //           closeOnClick: true,
      //           pauseOnHover: true,
      //           draggable: true,
      //           icon: false,
      //           closeButton: (
      //             <button
      //               className="text-black "
      //               onClick={() => toast.dismiss()}
      //               style={{
      //                 backgroundColor: "transparent",
      //                 border: "none",
      //                 marginBottom: "2.813rem",
      //               }}
      //             >
      //               ✖
      //             </button>
      //           ),
      //           className: "error-toast text-md  rounded text-black",
      //         }
      //       );
      //     }
      //   } finally {
      //     setTimeout(function () {
      //       setLoading(false); // Ensure `loading` is false first
      //     }, 100);
      //   }
      // }
      if (option.value == "pdf") {
        try {
          if (secondStrategyData && secondStrategyData.length > 0) {
            setIsHiddenTable(true);
          } else {
            setIsHiddenTable(false);
            setLoading(false);
          }
        } catch (err) {
          setIsHiddenTable(false);
          setLoading(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [secondStrategyData] // Dependencies
  );

  const handleDownloadPDFTable = async () => {
    const date = new Date().toLocaleString();
    const strategyTableHTML = generateStrategyTableHTML(secondStrategyData);

    const fullHtml = `
          <!DOCTYPE html>
          <html>
            <head>
              <meta charset="utf-8" />
              <style>
              @page {
        size: A4 landscape;
        margin: 0;
      }
        html, body {
                margin: 0;
                padding: 0;
                          font-family:sans-serif;
        overflow: auto;  /* Ensure content can overflow */
      
                height: 100%; /* Ensure the body fills the entire height */
              }        .pdf-container {
                  max-width: 100% !important;
                  margin: 20px;
                }
                tr {
                  page-break-inside: avoid !important;
                  break-inside: avoid !important;
                }
        
                .custom-header {
                  position: relative;
                  display: flex;
                  justify-content: space-between;
                  background-color: #ffffff;
                  padding-top: 10px; /* Ensures no padding at the top */
               margin-bottom: 10px;
                  }
        
                .logo-container {
                  display: flex;
                  align-items: center;
                }
        
                .logo {
                  width: 96px; /* Tailwind w-24 = 6rem = 96px */
                  max-width: 150px;
                  height: auto;
                  object-fit: contain;
                  margin-right: 1rem;
                }
        
                .title {
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  font-size: 1.125rem; /* Tailwind text-lg */
                  font-weight: 500;    /* Tailwind font-medium */
                  padding: 0;          /* Remove any padding */
                  margin: 0;           /* Remove any margin */
                }
        
                .date {
                  font-size: 0.875rem;  /* Tailwind text-sm */
                  font-weight: 500;
                  color: #000000;
                  padding-bottom: 16px;
                }
      
        
      .page-break {
               page-break-before: always;
        break-before: page;
        display: block;
        height: 0; /* No extra space */
        width: 100%;
        content: "";}
            table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }
      
          thead {
            font-size: 10px;
            color: #6B7280; /* Tailwind text-labelColour equivalent */
          }
      
          th {
            border-bottom: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
                td {
            padding: 6px;
            font-size: 10px;
            vertical-align: middle;
            text-align: left;
          }
            .tbody-tr{
                        background-color: #F9F9F9;
                        margin-bottom: 10px;
      
            }
              </style>
            </head>
            <body>
           <div class="pdf-container">
              <div class="custom-header">
                <div class="logo-container">
                  <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                </div>
                <h2 class="title">Buy & Sell Report - Caprock Model Portfolio - ${investmentProductName} </h2>
                <div class="date">${date}</div>
              </div>
              
         ${strategyTableHTML}

          
            </div> 
      
                 </body>
          </html>
        `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Buy & Sell Report - Caprock Model Portfolio -${investmentProductName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTable(false);
  };
  function generateStrategyTableHTML(strategyData) {
    return strategyData
      .map((category, categoryIdx) => {
        const headerBg =
          category.category_name.toUpperCase() === "GROWTH"
            ? "background: linear-gradient(to right, #93c5fd, #3b82f6); color: white;border-top-left-radius: 10px; border-top-right-radius: 10px;"
            : "background: linear-gradient(to right, #86efac, #22c55e); color: white;border-top-left-radius: 10px; border-top-right-radius: 10px;";

        const categoryHeader = `
        <div style="${headerBg} font-weight: bold; padding: 12px 16px; font-size: 14px;">
          ${category.category_name.toUpperCase()}
        </div>`;

        const productsHtml = category.products
          .map((product, productIdx) => {
            const rows = product.stocks
              .map((stock, stockIdx) => {
                return `
                <tr style="background-color: ${
                  stockIdx % 2 === 0 ? "#ffffff" : "#f9f9f9"
                };">
                  <td style="padding: 6px; font-size: 10px; color: #1f2937;">${
                    stock.stock_name
                  }</td>
                  <td style="padding: 6px; font-size: 10px; color: #4b5563;">${
                    stock.asx_code
                  }</td>
                  <td style="padding: 6px; font-size: 10px;">${
                    stock.available_quantity
                      ? stock.available_quantity
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "00"
                  }</td>
                  <td style="padding: 6px; font-size: 10px;">
                    <span style="background: #d1fae5; color: #065f46; padding: 2px 6px; font-size: 10px; border-radius: 9999px;">
                      ${
                        stock.current_allocation
                          ? stock.current_allocation.toFixed(2)
                          : "00.00"
                      }
                    </span>
                  </td>
                  <td style="padding: 6px; font-size: 10px;">
                    <span style="background: #fef9c3; color: #92400e; padding: 2px 6px; font-size: 10px; border-radius: 9999px;">
                      ${
                        stock.required_allocation
                          ? stock.required_allocation.toFixed(2)
                          : "00.00"
                      }%
                    </span>
                  </td>
                  <td style="padding: 6px; font-size: 10px; font-weight: 600; color: #1d4ed8;">
                    ${
                      stock.buy_quantity
                        ? stock.buy_quantity
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "00"
                    }
                  </td>
                  <td style="padding: 6px; font-size: 10px; font-weight: 600; color: #dc2626;">
                    ${
                      stock.sell_quantity
                        ? stock.sell_quantity
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "00"
                    }
                  </td>
                </tr>`;
              })
              .join("");

            return `
            <div style="background-color: #f3f4f6;">
              <div style="padding: 8px 16px; font-weight: 600; color: #005A9C; background-color: #f9fafb; border-bottom: 1px solid #d1d5db; font-size: 12px;">
                ${String(productIdx + 1).padStart(2, "0")}. ${
              product.product_name
            }
              </div>
              <div style="overflow-x: auto;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                  <thead>
                    <tr style="background-color: #e5e7eb; color: #374151;">
                      <th style="padding: 8px; text-align: left;">Stock Name</th>
                      <th style="padding: 8px; text-align: left;">ASX Code</th>
                      <th style="padding: 8px; text-align: left;">Available Quantity</th>
                      <th style="padding: 8px; text-align: left;">Current Allocation (%)</th>
                      <th style="padding: 8px; text-align: left;">Required Allocation (%)</th>
                      <th style="padding: 8px; text-align: left;">Buy Quantity</th>
                      <th style="padding: 8px; text-align: left;">Sell Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${rows}
                  </tbody>
                </table>
              </div>
            </div>`;
          })
          .join("");

        return `
        <div style="border: 1px solid #e5e7eb; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 24px;">
          ${categoryHeader}
          ${productsHtml}
        </div>`;
      })
      .join("");
  }
  useEffect(() => {
    if (isHiddenTable == true) {
      handleDownloadPDFTable();
    }
  }, [isHiddenTable]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (DownloadRef.current && !DownloadRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="bg-white shadow-md rounded-md p-4">
        <div className="flex items-center border-b border-colour-custom ">
          <h1 className="text-lg font-medium mb-2">
            Caprock Model Portfolio - {investmentProductName}
          </h1>
        </div>
        <div className="flex mt-4 justify-center items-center border-b mb-4">
          <h3 className="text-md font-semibold mb-2 ">In Depth Comparision</h3>
        </div>
        {strategyData && strategyData.length > 0 && (
          <div>
            <div className="overflow-x-auto mt-4">
              <table className="table-auto border-collapse w-full text-sm">
                <thead>
                  <tr className="bg-[#6AA7D3] text-white font-semibold">
                    <th className="border border-white  px-4 py-2">No</th>
                    <th className="border border-white  px-4 py-2">
                      Strategic Asset Allocation
                    </th>
                    <th className="border border-white  px-4 py-2">Code</th>
                    <th className="border border-white  px-4 py-2">Quantity</th>
                    <th className="px-4 py-2 border border-white ">
                      Matched %
                    </th>
                  </tr>
                </thead>
                {isLoadingRebalacing ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(5)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    {strategyData.map((categoryData, categoryIndex) => (
                      <React.Fragment key={categoryIndex}>
                        {/* Category Row */}
                        <tr
                          className={`px-6 py-2 rounded-lg ${
                            categoryData.name.toUpperCase() == "GROWTH"
                              ? "bg-[#92C5EA]"
                              : "bg-[#A9D4AB]"
                          }`}
                        >
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold"
                          ></td>
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold"
                          >
                            {categoryData.name.toUpperCase()}
                          </td>
                          <td
                            colSpan={1}
                            className="border border-white  px-4 py-2 font-bold"
                          ></td>
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold"
                          ></td>
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold "
                          ></td>
                        </tr>

                        {/* Products */}
                        {categoryData.products.map((product, productIndex) => (
                          <React.Fragment key={productIndex}>
                            {/* Product Row */}
                            <tr
                              className={`text-[#005A9C] ${
                                categoryData.name.toUpperCase() == "GROWTH"
                                  ? "bg-[#C6DFF1]"
                                  : "bg-[#C0E2C1]"
                              }`}
                            >
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {(productIndex + 1).toString().padStart(2, "0")}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-semibold"
                              >
                                {product.name}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-semibold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                            </tr>

                            {/* Stocks */}
                            {product.stocks.map((stock, stockIndex) => (
                              <tr
                                key={stockIndex}
                                className={`text-[#black] ${
                                  categoryData.name.toUpperCase() == "GROWTH"
                                    ? "bg-[#E6F3FC]"
                                    : "bg-[#E7F5E8]"
                                }`}
                              >
                                <td className="border border-white px-4 py-2"></td>
                                <td className="border border-white px-4 py-2">
                                  {stock.stock_name}
                                </td>
                                <td className="text-center border border-white px-4 py-2">
                                  {stock.asx_code}
                                </td>
                                <td className="text-center border border-white px-4 py-2">
                                  {!stock.action_quantity
                                    ? "00"
                                    : stock.action_quantity
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                {/* <td className="text-center font-bold border border-white px-4 py-2 text-[#00695C]">
                                  {stock.current_percentage.toFixed(2)}
                                </td> */}
                                <td
                                  colSpan={1}
                                  className="border border-white px-4 py-2 font-bold flex justify-center items-center"
                                >
                                  <button
                                    disabled={true}
                                    className={`font-medium h-4 rounded-xl px-4 py-2 flex justify-between items-center focus:outline-none
                border-2 border-[#34C046] text-[#34C046] bg-white`}
                                  >
                                    <span>
                                      {stock.current_percentage.toFixed(2)}
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                        {/* Sub total row for each category */}
                        {/* <tr
                          className={`font-bold ${
                            categoryData.name.toUpperCase() == "GROWTH"
                              ? "bg-[#92C5EA]"
                              : "bg-[#A9D4AB]"
                          }`}
                        >
                          <td colSpan={1} className="border px-4 py-2"></td>
                          <td colSpan={2} className="border px-4 py-2">
                            SUB-TOTAL {categoryData.name}
                          </td>
                          <td colSpan={1} className="border px-4 py-2"></td>
                          <td colSpan={1} className="border px-4 py-2">
                            {categoryData.current_percentage.toFixed(2)}
                          </td>
                        </tr> */}
                      </React.Fragment>
                    ))}
                    <React.Fragment>
                      {/* Summary section */}
                      {/* <tr className="bg-[#EAEAEA] font-bold">
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                        <td colSpan={2} className="border px-4 py-2">
                          Summary
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                      </tr>
                      <tr className="bg-[#92C5EA]  font-bold">
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                        <td colSpan={2} className="border px-4 py-2">
                          {strategyData[0].name}
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={1} className="border px-4 py-2">
                                                 {strategyData[0].current_percentage.toFixed(2)}

                        </td>
                      </tr>
                      <tr className="bg-[#A9D4AB]  font-bold">
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                        <td colSpan={2} className="border px-4 py-2">
                          {strategyData[1].name}
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={1} className="border px-4 py-2">
                                                   {strategyData[1].current_percentage.toFixed(2)}

                        </td>
                      </tr>
                      <tr className="bg-[#CDCDCD] font-bold">
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={2} className="border px-4 py-2">
                          TOTAL PORTFOLIO
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>

                        <td colSpan={1} className="border px-4 py-2">
                          {(
                            strategyData[0].current_percentage +
                            strategyData[1].current_percentage
                          ).toFixed(2) || "-"}
                        </td>
                      </tr> */}
                    </React.Fragment>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        )}
      </div>
      <div className="bg-white shadow-md rounded-md p-4 mt-4">
        <div className="flex pb-4 flex-col sm:flex-row justify-between items-start sm:items-center border-b  px-4 mt-4 gap-2">
          <h3 className="text-md font-semibold">Buy & Sell Report</h3>
          <div ref={DownloadRef} className="relative">
            <div
              className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer bg-white"
              onClick={() => setIsOpen(!isOpen)}
            >
              <img
                src="/document-download.svg"
                alt="document-download"
                className="mr-2"
              />
              <span className="truncate">Download Report</span>
              <img
                src="/download-small-arrow.svg"
                alt="Dropdown"
                className="w-2 h-2 ml-auto"
              />
            </div>

            {isOpen && (
              <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                {options.map((option) => (
                  <li
                    key={option.value}
                    className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      downloadPDFTable(e, option);
                    }}
                  >
                    {option.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        {strategyData && strategyData.length > 0 && (
          <div className="space-y-6 mt-4">
            {strategyData.map((category, categoryIdx) => (
              <div
                key={categoryIdx}
                className="rounded-xl shadow-lg overflow-hidden border border-gray-200"
              >
                <div
                  className={`text-md font-bold px-4 py-3 ${
                    category.name.toUpperCase() === "GROWTH"
                      ? "bg-gradient-to-r from-blue-300 to-blue-500 text-white"
                      : "bg-gradient-to-r from-green-300 to-green-500 text-white"
                  }`}
                >
                  {category.name.toUpperCase()}
                </div>

                <div className="divide-y divide-gray-200">
                  {category.products.map((product, productIdx) => (
                    <div key={productIdx} className="bg-white">
                      <div className="px-4 py-2 font-semibold text-[#005A9C] bg-gray-100 border-b border-gray-300 text-sm sm:text-base">
                        {String(productIdx + 1).padStart(2, "0")}.{" "}
                        {product.name}
                      </div>

                      {/* Table Wrapper for Horizontal Scroll */}
                      <div className="overflow-x-auto">
                        <table className="min-w-[768px] w-full text-sm text-left">
                          <thead>
                            <tr className="bg-gray-200 text-gray-700">
                              <th className="px-4 py-3">Stock Name</th>
                              <th className="px-4 py-3">ASX Code</th>
                              <th className="px-4 py-3">Available Quantity</th>
                              <th className="px-4 py-3">
                                Current Allocation (%)
                              </th>
                              <th className="px-4 py-3">
                                Required Allocation (%)
                              </th>
                              <th className="px-4 py-3">Buy Quantity</th>
                              <th className="px-4 py-3">Sell Quantity</th>
                            </tr>
                          </thead>
                          <tbody>
                            {product.stocks.map((stock, stockIdx) => (
                              <tr
                                key={stockIdx}
                                className="even:bg-gray-50 hover:bg-blue-50 transition"
                              >
                                <td className="px-4 py-2 w-48 min-w-0 whitespace-normal break-words text-gray-800">
                                  {stock.stock_name}
                                </td>
                                <td className="px-4 py-2 text-gray-600">
                                  {stock.asx_code}
                                </td>
                                <td className="px-4 py-2 text-gray-800">
                                  {stock.action_quantity
                                    ? stock.action_quantity.toLocaleString()
                                    : "00"}
                                </td>
                                <td className="px-4 py-2">
                                  <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">
                                    {stock.current_percentage.toFixed(2)}%
                                  </span>
                                </td>
                                <td className="px-4 py-2">
                                  <span className="inline-block bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-1 rounded-full">
                                    {stock.current_percentage.toFixed(2)}%
                                  </span>
                                </td>
                                <td className="px-4 py-2 text-blue-700 font-semibold">
                                  {stock.action_quantity
                                    ? stock.action_quantity.toLocaleString()
                                    : "00"}
                                </td>
                                <td className="px-4 py-2 text-red-600 font-semibold">
                                  {stock.action_quantity
                                    ? stock.action_quantity.toLocaleString()
                                    : "00"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default InDepthStrategyDetails;
